// extracted by mini-css-extract-plugin
export default {"hideBlock":"RedPill_hideBlock__huP-p","showDiv":"RedPill_showDiv__6w3Q7"};